import { useEffect, useState } from "react";

import {
  applyResolvedColorTheme,
  oppositeColorTheme,
  selectColorTheme,
  watchColorTheme,
  type ColorTheme,
} from "../theme";

export function useColorTheme(): ColorTheme {
  const [theme, setTheme] = useState<ColorTheme>(() =>
    typeof document === "undefined" ? "dark" : applyResolvedColorTheme(),
  );

  useEffect(() => watchColorTheme(setTheme), []);
  return theme;
}

export function ThemeToggle({
  variant,
}: {
  readonly variant: "rail" | "entry";
}) {
  const theme = useColorTheme();
  const next = oppositeColorTheme(theme);
  const label = next === "dark" ? "Use dark scheme" : "Use light scheme";

  return (
    <button
      className={
        variant === "rail"
          ? "rail-link theme-toggle"
          : "theme-toggle theme-toggle--entry"
      }
      type="button"
      aria-label={label}
      aria-pressed={theme === "dark"}
      data-theme-icon={theme === "dark" ? "moon" : "sun"}
      title={label}
      onClick={() => {
        selectColorTheme(next);
      }}
    >
      <svg
        className="rail-icon"
        viewBox="0 0 20 20"
        aria-hidden="true"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {theme === "dark" ? (
          <path d="M16.2 11.4A6.6 6.6 0 0 1 8.6 3.8 7.4 7.4 0 1 0 16.2 11.4z" />
        ) : (
          <>
            <circle cx="10" cy="10" r="3.15" />
            <path d="M10 1.8v1.7M10 16.5v1.7M1.8 10h1.7M16.5 10h1.7M4.05 4.05l1.2 1.2M14.75 14.75l1.2 1.2M4.05 15.95l1.2-1.2M14.75 5.25l1.2-1.2" />
          </>
        )}
      </svg>
      <span className={variant === "rail" ? "rail-label" : undefined}>
        {theme === "dark" ? "Dark" : "Light"}
      </span>
    </button>
  );
}
